module.exports = __webpack_public_path__ + "media/images/img/seikousya/nttcom-371a83e8bc8c9bec6bb0ec930ed5ef9f.png";